import * as fetch from './fetch';
import * as utils from '../utils.js';

export function logIn(loginRequest) {
  return fetch.POST("/auth/login", null, JSON.stringify(loginRequest), false)
}

export function addUserToCompany(companyId, newUserRequest, token) {
  const endpoint = '/users/ofCompany/' + companyId;
  return fetch.POST(endpoint, token, newUserRequest, true);
}

export function getUsersOfCompany(companyId, token) {
  const endpoint = `/users/ofCompany/${companyId}`;
  return fetch.GET(endpoint, token, true);
}

export function deleteUser(userId, token) {
  const endpoint = `/users/requestDataDeletion`;
  let postBody = {
    userId: userId,
    vendorId: utils.SefLinkVendorID
  };
  return fetch.POST(endpoint, token, postBody, true);
}

export function getLastLoginOfUser(userId, token) {
  const endpoint = `/users/${userId}/lastLogin`;
  return fetch.GET(endpoint, token, true);
}

